import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL } from '../constants';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 md:py-10 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-6 mb-6 items-start">
          {/* Company Info */}
          <div className="space-y-2">
            <div className="inline-flex flex-col items-center gap-0">
              <img src={LOGO_URL} alt="FURNIFLEX" className="h-14 md:h-16 w-auto object-contain block brightness-0 invert" />
              <span className="text-xs font-medium text-gray-400 tracking-wide text-center">your space, your way</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Transforming property ownership into a hassle-free, profitable experience. Let us handle the complexities while you reap the rewards.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold uppercase mb-3 tracking-wide">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/for-owners" className="text-gray-400 hover:text-white transition-colors text-sm">
                  For Owners
                </Link>
              </li>
              <li>
                <Link to="/for-tenants" className="text-gray-400 hover:text-white transition-colors text-sm">
                  For Tenants
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Owner Services */}
          <div>
            <h3 className="text-base font-bold uppercase mb-3 tracking-wide">Owner Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Professional Management
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Tenant Screening
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Guaranteed Rent
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Regular Inspection
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Value Enhancement
                </Link>
              </li>
              <li>
                <Link to="/services/maintenance-resolution" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Timely Maintenance
                </Link>
              </li>
            </ul>
          </div>

          {/* Tenant Services */}
          <div>
            <h3 className="text-base font-bold uppercase mb-3 tracking-wide">Tenant Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/hassle-free-move-ins" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Hassle-Free Move-Ins
                </Link>
              </li>
              <li>
                <Link to="/services/flatmate-matching" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Flatmate Matching
                </Link>
              </li>
              <li>
                <Link to="/services/maintenance-resolution" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Maintenance Resolution
                </Link>
              </li>
              <li>
                <Link to="/services/amenities-package" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Amenities Package
                </Link>
              </li>
              <li>
                <Link to="/services/flexible-leasing-options" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Flexible Leasing Options
                </Link>
              </li>
              <li>
                <Link to="/services/vetted-properties" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Vetted Properties
                </Link>
              </li>
              <li>
                <Link to="/services/neighborhood-guidance" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Neighborhood Guidance
                </Link>
              </li>
              <li>
                <Link to="/services/paperwork-assistance" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Paperwork Assistance
                </Link>
              </li>
              <li>
                <Link to="/services/24-7-support" className="text-gray-400 hover:text-white transition-colors text-sm">
                  24/7 Support
                </Link>
              </li>
              <li>
                <Link to="/services/community-events" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Community Events
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Follow Us Section */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="text-center">
            <h3 className="text-base font-bold uppercase mb-6 tracking-wide">Follow Us On:</h3>
            <div className="flex justify-center items-center gap-6 flex-wrap">
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/share/16aLFGRAZC/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
                aria-label="Facebook"
              >
                <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="text-white">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </div>
                <span className="text-white text-sm">Facebook</span>
              </a>
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/furniflex.in?igsh=MThtMW9iaDFobHN5Yg%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
                aria-label="Instagram"
              >
                <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="text-white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </div>
                <span className="text-white text-sm">Instagram</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

